import {
  StyleSheet,
} from 'react-native';

export default StyleSheet.create({
  backgroundImage: {
    position: 'relative',
    backgroundColor: 'white',
    width: 64,
    height: 64,
    minHeight: 64,
    maxHeight: 64,
    // borderRadius: 32,
    borderWidth: 0,
    borderColor: 'white',
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
    // marginRight: 6,
    padding: 0,
    // resizeMode: 'stretch',
  },
  backgroundImageDefault: {
    transform: [
      { scale: 0.5 },
    ],
  },
  activityIndicator: {
    position: 'absolute',
    // margin: 'auto',
    zIndex: 9,
    margin: 0,
    padding: 0,
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
  },
  viewImageStyles: {
    width: 64,
    height: 64,
    minHeight: 64,
    maxHeight: 64,
    borderRadius: 8,
    overflow: 'hidden',
    // flex: 1,
    marginRight: 6,
    borderWidth: 0,
    // backgroundColor: 'transparent',
    backgroundColor: 'white',
    // backgroundColor: '#e9eef1',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 0,
    padding: 0,
    alignSelf: 'center',
  },
  imagePlaceholderStyles: {
    width: 64,
    height: 64,
    minHeight: 64,
    maxHeight: 64,
    // resizeMode: 'contain',
    justifyContent: 'center',
    alignItems: 'center',
  },
  viewChildrenStyles: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    position: 'absolute',
  },
});
